import qs from 'qs';
import client, { url } from './client';

// 키오스크 상품 목록 조회
export const loadKioskProductAll = ({ clubID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  console.log(`loadKioskProductAll : ${clubID}, ${socketKey}`)
  return client.get(`${url}/api/kiosk/product/${clubID}?${queryString}`);
};

// 키오스크 상품 활성화/비활성화
export const changeKioskProductActive = ({ clubID, clubKioskSalesItemID, isActive, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  console.log(`changeKioskProductActive : ${clubID}, ${clubKioskSalesItemID}, ${isActive}, ${socketKey}`)
  return client.post(`${url}/api/kiosk/product/${clubID}/${clubKioskSalesItemID}/${isActive}?${queryString}`);
};

// 키오스크 상품 삭제
export const deleteKioskProduct = ({ clubID, clubKioskSalesItemID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  console.log(`deleteKioskProduct : ${clubID}, ${clubKioskSalesItemID}, ${socketKey}`)
  return client.delete(`${url}/api/kiosk/product/${clubID}/${clubKioskSalesItemID}?${queryString}`);
};

// 키오스크 상품 순서 변경
export const changeKioskProductOrder = ({ clubID, clubKioskSalesItemID, direction, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  console.log(`changeKioskProductOrder : ${clubID}, ${clubKioskSalesItemID}, ${direction}, ${socketKey}`)
  return client.post(`${url}/api/kiosk/product/order/${clubID}?${queryString}`, { clubKioskSalesItemID, direction });
};

// 키오스크 상품 판매 상태 변경
export const changeKioskProductState = ({ clubID, kioskProductState, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  console.log(`changeKioskProductState : ${clubID}, ${kioskProductState}, ${socketKey}`)
  return client.post(`${url}/api/kiosk/product/state/${clubID}/${kioskProductState}?${queryString}`);
};

// 키오스크 상품 등록/수정
export const modifyKioskProduct = ({ clubID, socketKey, clubKioskSalesItemData, isNew }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  console.log(`modifyKioskProduct : ${clubID}, ${socketKey}, ${clubKioskSalesItemData}, ${isNew}`)
  return client.post(`${url}/api/kiosk/product/${clubID}?${queryString}`, { clubKioskSalesItemData, isNew });
};

